// extracted by mini-css-extract-plugin
export default {"header":"BQNi7","title":"hADX8","free":"OAETx","freeLabel":"E6Ncg"};